/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, Form, Button, InputGroup, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "react-mde/lib/styles/css/react-mde-all.css";
import * as Yup from "yup";
import Picker from "emoji-picker-react";
import * as actions from "../../../redux/actions/notifications";
import "./styles.css";
import { FormControl } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { CardBody } from "../../../_metronic/_partials/controls";
import { format } from "date-fns";
import { useRef } from "react";

export default function RestlessNotificationsCreationPage({ history, match }) {
  const dispatch = useDispatch();
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [selectContent, setSelectContent] = useState(null);
  const [selectContentError, setSelectContentError] = useState();
  const [attachedTo, setAttachedTo] = useState();
  const [onPressSearch, setOnPressSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [errorSearch, setErrorSearch] = useState();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const MAX_MARKDOWN_CHARACTERS = 150;
  const refPickerEmoji = useRef();

  const {
    categoriesList,
    error,
    articlesSearch,
    postSearch,
    userData,
    notificationsCreated,
  } = useSelector((state) => ({
    articlesSearch: state.notifications.articlesSearch,
    postSearch: state.notifications.postSearch,
    categoriesList: state.notifications.categoriesList,
    error: state.articles.error,
    userData: state.auth.user,
    notificationsCreated: state.notifications.notificationsCreated,
  }));

  useEffect(() => {
    dispatch(actions.fetchCategories());
  }, []);

  useEffect(() => {
    setSelectContent();
    actions.cleanStateNotifications(dispatch);
    setLoadingSearch(false);
    setSearch("");
    setErrorSearch();
  }, [attachedTo]);

  useEffect(() => {
    if (postSearch || articlesSearch) {
      setLoadingSearch(false);
      if (postSearch.length < 1 && attachedTo == "Post" && onPressSearch) {
        setErrorSearch("No results found");
        setOnPressSearch(false)
      }
      if (articlesSearch.length < 1 && attachedTo == "Resource" && onPressSearch) {
        setErrorSearch("No results found");
        setOnPressSearch(false)
      }
    }
  }, [postSearch, articlesSearch]);

  const initialValues = {
    content: "",
    category: "",
    attachetToContent: "",
    textSearch: "",
  };
 
  const attachetToContent = ["None","Post", "Resource"];

  const NotificationsSchema = Yup.object().shape({
    content: Yup.string()
      .max(MAX_MARKDOWN_CHARACTERS, "Maximum 150 Characters")
      .required("Content is a required field"),
    category: Yup.string().required("Category is a required field"),
    textSearch: Yup.string(),
  });

  const onEmojiClick = (event, emojiObject) => {
    setChosenEmoji(emojiObject);
  };

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    // When button submits form and form is in the process of submitting, submit button is disabled
    setSubmitting(true);

    if (!values.category) {
      setErrorSearch("You must select a option on Category");
      return;
    }

    if (!attachedTo) {
      setErrorSearch("You must select a option on Attached to");
      return;
    }
    
    if(attachedTo != "None" && !selectContent){
      setSelectContentError("You must select a option on Attached to");
      return;
    }

    const notificationData = {
      body: values.content,
      category: parseInt(values.category),
      article: values.attachetToContent == "Resource" && selectContent ? selectContent.id : "",
      post: values.attachetToContent == "Post" && selectContent ? selectContent.id : "",
      creator_restless_user: userData?.id,
    };

    dispatch(actions.createBespokeNotification(notificationData));

    setSubmitting(false);
  };

  const onSearch = () => {
    if (!attachedTo) {
      setErrorSearch("You must select a option on Attached to");
      return;
    }
    if (search == "") {
      setErrorSearch("The field is empty");
      return;
    }
    setSelectContent();
    setErrorSearch();
    setLoadingSearch(true);
    setOnPressSearch(true)
    if (attachedTo === "Resource") {
      dispatch(actions.searchArticles(search));
    }
    if (attachedTo === "Post") {
      dispatch(actions.searchPost(search));
    }
    if (attachedTo === "None") {
      actions.cleanStateNotifications(dispatch);
    }
  };

  const getInputClasses = (fieldname, touched, errors) => {
    if (touched[fieldname] && errors[fieldname]) {
      return "is-invalid";
    }
    return "";
  };

  const renderNotificationsError = (error) => {
    return (
      <Alert
        variant="danger"
        className="text-center"
        dismissible
        onClose={() => cleanErrors()}
      >
        {error}
      </Alert>
    );
  };



  const cleanErrors = (error) => {
    setErrorSearch();
    setSelectContentError();
    actions.cleanError(dispatch);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={NotificationsSchema}
        onSubmit={onSubmit}
      >
        {function Render({
          values,
          errors,
          touched,
          status,
          handleChange,
          handleSubmit,
          setFieldValue,
          getFieldProps,
        }) {
          useEffect(() => {
            if (chosenEmoji) {
              setFieldValue("content", values.content + chosenEmoji.emoji);
            }
          }, [chosenEmoji]);

          useEffect(() => {
            setSearch(values.textSearch);
          }, [values.textSearch]);

          useEffect(() => {
            setAttachedTo(values.attachetToContent);
            setFieldValue("textSearch", "");
          }, [values.attachetToContent]);

          useEffect(() => {
            if (notificationsCreated) {
              setFieldValue("content", "");
              setFieldValue("category", "");
              setFieldValue("attachetToContent", "");
              setFieldValue("textSearch", "");
              setSelectContent();
              history.goBack();
            }
          }, [notificationsCreated]);

          return (
            <>
              {(error || errorSearch || selectContentError) &&
                renderNotificationsError(
                  error || errorSearch || selectContentError
                )}
              <>
                <Form onSubmit={handleSubmit} className="h-100">
                  <div className="d-flex h-100">
                    <div className="w-75">
                      <Card className="h-100" >
                        <Card.Body>
                          <div class="d-flex justify-content-between">
                            <div class="mb-2">
                              <Form.Label>Notification Content</Form.Label>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                              <div className="EmojiPicker mt-3 mr-4">
                                <span
                                  onClick={() => setShow(!show)}
                                  className="svg-icon"
                                >
                                  <SVG
                                    height="40"
                                    src={toAbsoluteUrl(
                                      "/media/svg/Emoticon.svg"
                                    )}
                                  />
                                </span>
                                {show && (
                                  <div
                                  onMouseLeave={() => {
                                      if (show){
                                        setShow(false)
                                      }
                                    }}
                                    ref={refPickerEmoji}
                                    className="EmojiPicker__Wrapper"
                                  >
                                    <Picker
                                      onEmojiClick={onEmojiClick}
                                      native
                                    />
                                  </div>
                                )}
                              </div>
                              <Button
                                variant="primary"
                                onClick={handleSubmit}
                                type="submit"
                              >
                                Send
                              </Button>
                            </div>
                          </div>
                          <Form.Group controlId="formNotification">
                            <Form.Control
                              as="textarea"
                              name="content"
                              values={values.content}
                              onChange={handleChange}
                              type="text"
                              placeholder="Content"
                              rows={5}
                              className={getInputClasses(
                                "content",
                                touched,
                                errors
                              )}
                              {...getFieldProps("content")}
                              maxLength={150}
                            />
                            <div className="d-flex justify-content-end">
                              {values.content?.length}/{MAX_MARKDOWN_CHARACTERS}
                            </div>
                            {touched.content && errors.content ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.content}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>

                          <div className="row">
                            <div className="col-12">
                              <h4 className="mb-4 mt-4">Attached to</h4>
                            </div>
                            <div className="col">
                              {!selectContent && (
                                <div className="text-muted">
                                  Select a post or a resource
                                </div>
                              )}
                              {selectContent && (
                                <Card key={selectContent.id}>
                                  <CardBody>
                                    <div class="d-flex justify-content-between">
                                      <div class="mb-2">
                                        <span>
                                          {
                                            selectContent.restless_user
                                              .full_name
                                          }
                                        </span>
                                      </div>
                                      <div class="mb-2">
                                        <span>{selectContent.id}</span>
                                      </div>
                                    </div>
                                    <div class="mb-2 mt-2">
                                      {attachedTo == "Resource" && (
                                        <>
                                          <h3>{selectContent.title}</h3>
                                          <span>
                                            {selectContent.stand_first}
                                          </span>
                                        </>
                                      )}
                                      {attachedTo == "Post" && (
                                        <h5>
                                          {selectContent.body ||
                                            selectContent?.poll?.body}
                                        </h5>
                                      )}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                      <div class="mb-2">
                                        <span>
                                          {selectContent?.category?.name}
                                        </span>
                                      </div>
                                      <div class="mb-2">
                                        <span>
                                          {format(
                                            new Date(
                                              selectContent.published_at
                                            ),
                                            "MMMM dd, yyyy"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              )}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>

                    <div className="ml-5 w-25 h-100">
                      <Card className="h-100">
                        <Card.Body>
                          <Form.Group controlId="formCategory">
                            <Form.Label>Category</Form.Label>
                            <Form.Control
                              as="select"
                              name="category"
                              defaultValue
                              placeholder="Select a category"
                              onChange={handleChange}
                              value={values.category}
                              {...getFieldProps("category")}
                            >
                              {!values.category && <option>Select</option>}
                              {categoriesList.map((category) => (
                                <option key={category.id} value={category.id}>
                                  {category.name}
                                </option>
                              ))}
                              <option key={8} value={null}>
                                All
                              </option>
                            </Form.Control>
                            {touched.category && errors.category ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.category}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Group controlId="formAttachedTo">
                            <Form.Label>Attached to</Form.Label>
                            <Form.Control
                              as="select"
                              name="attachetToContent"
                              defaultValue
                              onChange={handleChange}
                              value={values.attachetToContent}
                              {...getFieldProps("attachetToContent")}
                            >
                              {!values.attachetToContent && (
                                <option>Select</option>
                              )}
                              {attachetToContent.map((content, index) => (
                                <option key={index.toString()} value={content}>
                                  {content}
                                </option>
                              ))}
                            </Form.Control>
                            {touched.attachetToContent &&
                            errors.attachetToContent ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.attachetToContent}
                                </div>
                              </div>
                            ) : null}
                          </Form.Group>
                          <Form.Label
                            htmlFor="inlineFormInputGroup"
                            visuallyHidden
                          >
                            Search
                          </Form.Label>
                          <InputGroup className="mb-3">
                            <FormControl
                              disabled={!(attachedTo == "Post" || attachedTo == "Resource")}
                              type="text"
                              name="textSearch"
                              placeholder={
                                !attachedTo
                                  ? "Search"
                                  : attachedTo == "Post"
                                  ? "Search by body or author"
                                  : "Search by title, body or stand-first"
                              }
                              onChange={() => setSearch(values.textSearch)}
                              value={values.textSearch}
                              {...getFieldProps("textSearch")}
                            />
                            <div class="mb-2">
                              <Button
                                disabled={!(attachedTo == "Post" || attachedTo == "Resource")}
                                className="btn btn-icon btn-primary"
                                variant={!attachedTo ? "second": "primary"}
                                onClick={onSearch}
                              >
                                <span className="svg-icon svg-icon-md">
                                  <SVG
                                    height="50"
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Search.svg"
                                    )}
                                  />
                                </span>
                              </Button>
                            </div>
                          </InputGroup>
                          {loadingSearch && (
                            <div className="d-flex justify-content-center align-items-center mb-5">
                              <div className="spinner spinner-primary mr-10"></div>
                            </div>
                          )}
                          {(articlesSearch?.length > 0 ||
                            postSearch?.length > 0) && (
                            <div
                              class="mb-2"
                              data-spy="scroll"
                              data-offset="0"
                              className="containerScroll"
                            >
                              {articlesSearch.map((article) => {
                                return (
                                  <Card
                                    key={article.id}
                                    className="mb-2 mr-2"
                                    onClick={() => setSelectContent(article)}
                                    style={
                                      article?.id == selectContent?.id
                                        ? {
                                            borderColor: "#94A2EE",
                                            borderWidth: 2,
                                          }
                                        : null
                                    }
                                  >
                                    <CardBody>
                                      <div class="d-flex justify-content-between">
                                        <div class="mb-2">
                                          <span>
                                            <b>
                                              {article.restless_user.full_name}
                                            </b>
                                          </span>
                                        </div>
                                        <div class="mb-2">
                                          <span>{article.id}</span>
                                        </div>
                                      </div>
                                      <div class="mb-2 mt-2">
                                        <span>{article.title}</span>
                                      </div>
                                      <div class="d-flex justify-content-between mt-6">
                                        <div class="mb-2">
                                          <span>{article.category.name}</span>
                                        </div>
                                        <div class="mb-2">
                                          <span>
                                            {format(
                                              new Date(article.published_at),
                                              "MMMM dd, yyyy"
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Card>
                                );
                              })}
                              {postSearch.map((post) => {
                                return (
                                  <Card
                                    key={post.id}
                                    onClick={() => setSelectContent(post)}
                                    className="mb-2 mr-2"
                                    style={
                                      post?.id == selectContent?.id
                                        ? {
                                            borderColor: "#94A2EE",
                                            borderWidth: 2,
                                          }
                                        : null
                                    }
                                  >
                                    <CardBody>
                                      <div class="d-flex justify-content-between">
                                        <div class="mb-2">
                                          <span>
                                            <b>
                                              {" "}
                                              {post.restless_user.full_name}
                                            </b>
                                          </span>
                                        </div>
                                        <div class="mb-2">
                                          <span>{post.id}</span>
                                        </div>
                                      </div>
                                      <div class="mb-4 mt-2">
                                        <div class="row">
                                          <div class="col-12 text-truncate">
                                            {post.body || post?.poll?.body}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="d-flex justify-content-between mt-6">
                                        <div class="mb-2">
                                          <span>{post.category?.name}</span>
                                        </div>
                                        <div class="mb-2">
                                          <span>
                                            {format(
                                              new Date(post.published_at),
                                              "MMMM dd, yyyy"
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Card>
                                );
                              })}
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </Form>
              </>
            </>
          );
        }}
      </Formik>
    </>
  );
}
